import { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';
import { IBaseUpdateFaqDTO, IFaqBase, IFaqSearchDTO } from '@/models/faqBase.model';

export enum GeneralFaqEndpoints {
  ROOT = '/faq-general',
}

export const staticGeneralFaqEndpoints = {
  GET_GENERAL_FAQS: GeneralFaqEndpoints.ROOT,
  CREATE_GENERAL_FAQ: GeneralFaqEndpoints.ROOT,
  DELETE_GENERAL_FAQS: GeneralFaqEndpoints.ROOT,
};

export const getGeneralFaqEndpoints = ({ faqId }: { faqId: string }) => ({
  UPDATE_GENERAL_FAQ: `${GeneralFaqEndpoints.ROOT}/${faqId}`,
});

export type IGeneralFaq = IFaqBase;

// ============== DTO ==============

export type IGetGeneralFaqsDTO = IPaginationDTO & IFaqSearchDTO;

export type ICreateGeneralFaqDTO = IBaseUpdateFaqDTO;

export interface IUpdateGeneralFaqDTO extends IBaseUpdateFaqDTO {
  faqId: string;
}

export interface IDeleteGeneralFaqsDTO {
  faqIds: string[];
}

// ============== Response ==============

export interface IGetGeneralFaqsResponse extends IPaginationResponse {
  faqs: IGeneralFaq[];
}

export type ICreateGeneralFaqResponse = IGeneralFaq;
